import { createReducer } from '@reduxjs/toolkit';
import {
    SET_IS_LOADING_SPOT_DATA,
    SET_SPOT_DATA,
    SET_SPOT_MODAL_OPEN,
} from '../actions/spotActions';

const initialState = {
    spotSlug: '',
    spotData: {},
    isLoadingSpotData: true,
    spotModalOpen: false,
};

const spot = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SPOT_DATA, (state, action) => {
            state.spotSlug = action.spotSlug;
            state.spotData = action.spotData;
        })
        .addCase(SET_IS_LOADING_SPOT_DATA, (state, action) => {
            state.isLoadingSpotData = action.isLoading;
        })
        .addCase(SET_SPOT_MODAL_OPEN, (state, action) => {
            state.spotModalOpen = action.spotModalOpen;
        });
});

export default spot;
